import { render, staticRenderFns } from "./ExtratoClientes2.vue?vue&type=template&id=e36ef93e&scoped=true&"
import script from "./ExtratoClientes2.vue?vue&type=script&lang=js&"
export * from "./ExtratoClientes2.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoClientes2.vue?vue&type=style&index=0&id=e36ef93e&scoped=true&lang=css&"
import style1 from "./ExtratoClientes2.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36ef93e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VChip,VCol,VContainer,VDivider,VIcon,VListItem,VListItemAction,VListItemTitle,VRow,VSelect,VTooltip})
